import { Box, Button, Drawer, DrawerContent,  DrawerOverlay, Heading, Text,  useDisclosure,  VStack } from "@chakra-ui/react"
import React from 'react'
import { BsChevronRight,BsArrowRight } from "react-icons/bs"
function DrawerProducts() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  
    return (
      <>
        <Button   variant="link" size="md" colorScheme="black" onMouseEnter={onOpen}>
          Products
        </Button>
        <Drawer
          size="md"
          isOpen={isOpen}
          placement='left'
          onClose={onClose}
        >
          <DrawerOverlay />
          <DrawerContent>
            <Box scrollTop="0px" overflowY="scroll" p="1rem">
                <VStack spacing={"2rem"} align='stretch'>
                  <Box pb="2rem" borderBottom="1px solid grey">
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Text>WE'LL HELP YOU —</Text>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading  as="h1"  size="lg" fontWeight="400">Get Your Business Online</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Market Your Business</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                    </VStack> 
                  </Box>
                  <Box pb="2rem" borderBottom="1px solid grey">
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Text>PLATFORM FEATURES —</Text>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Audience Management</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Box  _hover={{color:"teal", cursor:"pointer"}}display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Creative Tools</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Box  _hover={{color:"teal", cursor:"pointer"}}display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Marketing Automation</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                      <Box  _hover={{color:"teal", cursor:"pointer"}}display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">Insights & Analytics</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                    </VStack> 
                  </Box>
                  <Box pb="2rem" borderBottom="1px solid grey">
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Text>NOT SURE WHERE TO START? —</Text>
                      <Box _hover={{color:"teal", cursor:"pointer"}} display="flex" alignItems="center" justifyContent="space-between">
                        <Heading as="h1"  size="lg" fontWeight="400">What's Right for Me?</Heading>
                        <BsChevronRight fontSize="30px"/>
                      </Box>
                    </VStack> 
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Heading _hover={{color:"teal", cursor:"pointer"}} as="h1"  size="lg" fontWeight="400">Talk to Sales: +1(800)315-5939</Heading>
                    </VStack>
                  </Box>
                  <Box>
                    <VStack spacing={"1.5rem"} align='stretch'>
                      <Heading as="h5" fontSize="20px" fontWeight="medium">Products Updates</Heading>
                      <Text>Get the latest on new features, product improvements, and other announcements.</Text>
                      <Box w="30%" display="flex" justifyContent="space-between" alignItems="center">
                        <Button colorScheme='teal' variant='link'>See what's new </Button>
                        <BsArrowRight fontSize="20px" color="teal"/>
                      </Box>
                    </VStack>
                  </Box>
                  </VStack>
            </Box>
          </DrawerContent>
        </Drawer>
      </>
    )
  }
  export default DrawerProducts